var React = require('react');

function X (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0 0)"},React.createElement("g",{"className":"fillable","fill":"#F7F7F7"},React.createElement("path",{"d":"M18.42,14.009L27.891,3h-2.244l-8.224,9.559L10.855,3H3.28l9.932,14.455L3.28,29h2.244l8.684-10.095,6.936,10.095h7.576l-10.301-14.991h0Zm-3.074,3.573l-1.006-1.439L6.333,4.69h3.447l6.462,9.243,1.006,1.439,8.4,12.015h-3.447l-6.854-9.804h0Z"}))));
}

X.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = X;

X.default = X;
